export const dariafthaReducer = (state = [], action) => {
    switch (action.type) {
        case "DRFTHA":
            return [...action.payload];
        default:
            return state;
    }
};
